// @flow
import * as React from 'react';
import Box from 'sail/Box';
import {Link} from 'docs/components';
import {useVideos} from 'docs/data';
import {Card, CardFooter, CardHeader, CardBody} from './framework';

type VideoPlaylistProps = {|
  playlist: string,
  thumbnail: string,
  id?: string,
  className?: string,
  children?: React.Node,
  href: string,
|};

export const VideoPlaylistCard = ({
  playlist,
  thumbnail,
  id,
  className = '',
  children,
  href,
}: VideoPlaylistProps) => {
  const videos = useVideos({prefetchAllVideos: true});
  const fetchedPlaylist = videos.getPlaylist(playlist);

  if (!fetchedPlaylist) {
    return '';
  }

  return (
    <Card bordered>
      <Link href={href} title={fetchedPlaylist.title}>
        <CardHeader text={fetchedPlaylist.title} />
        <Box id={id} padding={{top: 32, bottom: 12}}>
          <img alt="" src={thumbnail} width="100%" />
        </Box>
      </Link>
      <CardBody>{fetchedPlaylist.description} </CardBody>
      <CardFooter icon={{category: 'general', icon: 'list'}}>
        {`${fetchedPlaylist.chapters.length} videos`}
      </CardFooter>
    </Card>
  );
};
